import script from "./UploadCom.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadCom.vue?vue&type=script&setup=true&lang=js"

import "./UploadCom.vue?vue&type=style&index=0&id=5b397861&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b397861"]])

export default __exports__